import { H1A } from '#ui/Hax.tsx'
import { SidebarWrap } from '#ui/Sidebar/SidebarWrap.tsx'

export function SidebarPlaceholder() {
  return (
    <SidebarWrap>
      <H1A className={x => x('mb-3 border-b-dotted-2 py-3')} to='/app'>
        pagespeedlog.com
      </H1A>
    </SidebarWrap>
  )
}
